import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';
import {
  CreateCvSectionTextRequest,
  CvSectionText,
  CvSectionTextResponse,
} from '@/../gen';

export const namespace = 'cvSectionTextNew';
const actionCreator = actionCreatorFactory(namespace);
export const SetCvSectionText = actionCreator<CvSectionTextResponse>(
  'SET_CV_SECTION_TEXT'
);
export const CreateCvSectionText = actionCreator<{
  params: {
    cv_id: number;
  };
  body: CreateCvSectionTextRequest;
}>('CREATE_CV_SECTION_TEXT');
export const ResetState = actionCreator<null>('RESET_STATE');

export interface State {
  cvSectionText: CvSectionText;
}

const initialState = (): State => {
  return { cvSectionText: null };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(CreateCvSectionText, async function(context, action) {
      const { data } = await this.proffApi.createCvSectionText(
        action.payload.params.cv_id,
        action.payload.body
      );
      context.commit(SetCvSectionText(data.data));
    }),
    action(ResetState, function(context, action) {
      context.commit(ResetState(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(SetCvSectionText, (state, action) => {
      state.cvSectionText = action.payload?.attributes;
    }),
    mutation(ResetState, state => {
      Object.assign(state, initialState());
    })
  ),
  getters: {
    cvSectionText: state => state.cvSectionText,
  },
};
